import {
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonLabel,
  IonInput,
  IonPage,
  IonButton,
  IonHeader,
  IonFooter,
  IonModal,
  IonCheckbox,
} from "@ionic/react";
import React, { SyntheticEvent, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { useForm } from "react-hook-form";
import { format } from "date-fns";
import ErrorTopToaster from "../components/ErrorTopToaster";
import { PatientVM } from "../models/PatientVM";
import { ActionType, Lookups, PatientSetting } from "../models/Enums";
import {
  createPatientStep2State,
  IseditingLookupsState,
  isShowToast,
  newAllDropDownState,
  PatientState,
} from "../data/atoms";
import { useRecoilState } from "recoil";
import {
  GetGeneralLookupData,
  RegisterPatientAuth,
  SaveRecentSearchAuth,
} from "../services/AuthServices";
import {
  numberValidation,
  verifiyNameWithPattern,
  getFormatedMobileNumber,
  validationNamePattern,
} from "../utils/sharedFunction";
import TopLeftUserName from "../components/TopLeftUserName";
import SelectSectionCustom from "../components/SelectSectionCustom";
import CancelModal from "../components/modals/cancel-modal";
import { dropDownOption, Option } from "../models/Option";
import { PatientFormDropdowns } from "../models/PatientFormDropdowns";
import TagsName from "../components/TagsName";
import CreateNewLookup from "../components/modals/create-new-lookup";
import Loader from "../components/LoaderComponent";

interface Props {
  props: any;
}
type FormParams = {
  firstname: string;
  lastname: string;
  nickname: string;
  dob: Date;
  dobFormatted: string;
  email: string;
  zipcode: string;
  setting: string;
  referral: any;
  physician: any;
  department: any;
  phone: string;
  mrn: string;
  testPatient: boolean;
};
const CreateNewPatientStep1: React.FC<Props> = ({ props }) => {
  const modal = useRef<HTMLIonModalElement>(null);
  const [patientDetailsRecoil, setPatientDetailsRecoil] =
    useRecoilState(PatientState);
  const [patientDetails, setPatientDetails] =
    useState<PatientVM>(patientDetailsRecoil);
  const getDatafromId = (id: number) => {
    if (id == 6) {
      return;
    }
    let LookupId: string = PatientSetting[id] as unknown as string;
    return LookupId;
  };
  let isEdit = props == undefined ? true : props?.props;
  let history = useHistory();
  const [createPatientStep2, setCreatePatientStep2] = useRecoilState(
    createPatientStep2State
  );
  const [errorStringDisplay, seterrorStringDisplay] = useState<string>("");
  const [isTestPatient, setisTestPatient] = useState<boolean>(false);
  const [newAllDropDown, setNewAllDropDown] =
    useRecoilState<PatientFormDropdowns>(newAllDropDownState);
  // const [newAllDropDown, setNewAllDropDown] = useState<PatientFormDropdowns>(allRecoilDropDown);
  const [showToast, setShowToast] = useRecoilState(isShowToast);
  const [selectSettingOption, setSelectSettingOption] = useState(
    patientDetails?.patientSetting ? patientDetails?.patientSetting : ""
  );
  const [settingToggle, setSettingToggle] = useState<boolean>(false);
  const [cancelModal, setcancelModal] = useState<boolean>(false);
  const [isLookupUpdated, setIsLookupUpdated] = useState("");
  const [tagsList, setTagsList] = useState<Option[]>([]);
  const [diagnosisList, setDiagnosisList] = useState<Option[]>([]);
  const [lookUpOption, setLookUpOption] = useState<boolean>(false);
  const [isDropDown, setIsDropDown] = useState<boolean>(false);
  const [lookType, setLookupType] = useState<any>("");
  const [iseditingLookup, setIseditingLookup] = useRecoilState(
    IseditingLookupsState
  );
  // console.log("newAllDropDown: ", newAllDropDown);
  const [lookUpType, setLookUpType] = useState<Lookups>(0);
  const [settingError, setSettingError] = useState<boolean>(false);
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  let location =
    window.location.href == window.location.origin + "/home" ? true : false;
  const initializerFunction = async () => {
    try {
      await initializeAllArrays();
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    // setNewAllDropDown(new PatientFormDropdowns);
    initializerFunction();
    return () => {
      clearErrors();
      setSettingError(false);
      setCreatePatientStep2(false);
      // reset()
    };
  }, [location]);

  useEffect(() => {}, [selectSettingOption]);

  useEffect(() => {
    // console.log("create patient useeffect")
    initializerFunction();
    if (isEdit && patientDetails !== null && patientDetails !== undefined) {
      setisTestPatient(patientDetails!?.isTestPatient);
      setIsDisabled(false);
    }

    // setIsDisabled(false);
  }, []);

  const {
    register,
    setError,
    handleSubmit,
    reset,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm<FormParams>({
    defaultValues: {
      firstname: patientDetails!?.firstName,
      lastname: patientDetails!?.lastName,
      nickname: patientDetails!?.nickName,
      dob: patientDetails!?.dob,
      email: patientDetails!?.email,
      zipcode: patientDetails!?.zip,
      mrn: patientDetails!?.mrn,
      phone: getFormatedMobileNumber(patientDetails!?.mobilePhone!),
      setting: getDatafromId(patientDetails!?.patientSetting),
      referral: "",
      physician: "",
      department: "",
      testPatient: isEdit ? patientDetails!?.isTestPatient : false,
      dobFormatted:
        patientDetails?.dob == undefined || patientDetails?.isNew == true
          ? ""
          : format(new Date(patientDetails?.dob), "MM/dd/yyyy"),
    },
  });

  const settingValidation = () => {
    if (newAllDropDown.setting.id == undefined) {
      setSettingError(true);
    }
  };
  const goBack = () => {
    localStorage.removeItem("registerPatient");
    reset();
    history.goBack();
  };
  const checkErrors = () => {
    console.log("errors: ", errors);
    if (Object.keys(errors).length === 0) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  };
  const namingtValidation = (e: Event, name: string) => {
    //validation
    // console.log("namingValidation name", name)
    let verifyName = verifiyNameWithPattern(
      (e.target as HTMLInputElement).value
    );
    if (!verifyName.isSuccess) {
      setIsDisabled(true);
      if (name === "fName") {
        setError("firstname", {
          type: "validate",
          message: verifyName.error.replace("Data", "First"),
        });
      } else if (name === "nickName") {
        setError("nickname", {
          type: "validate",
          message: verifyName.error.replace("Data name", "Nickname"),
        });
      } else {
        setError("lastname", {
          type: "validate",
          message: verifyName.error.replace("Data", "Last"),
        });
      }
      // e.target.value = e.target.value.slice(0, -1);
    } else {
      // setIsDisabled(false);
      if (name === "fName") {
        setPatientDetails((prevState: any) => ({
          ...prevState,
          firstName: (e.target as HTMLInputElement).value,
        }));
        clearErrors("firstname");
      } else if (name === "nickName") {
        setPatientDetails((prevState: any) => ({
          ...prevState,
          nickName: (e.target as HTMLInputElement).value,
        }));
        clearErrors("nickname");
      } else {
        setPatientDetails((prevState: any) => ({
          ...prevState,
          lastName: (e.target as HTMLInputElement).value,
        }));
        clearErrors("lastname");
      }
      try {
        checkErrors();
      } catch (e) {
        console.log(e);
      }
    }
    // state update
  };

  const dobValidation = (e: Event) => {
    clearErrors("dobFormatted");
    localStorage.setItem("iseditingDob", "1");
    if (
      ((e.target as HTMLInputElement).value.length != 0 ||
        patientDetails?.dobFormatted?.length! == 1) &&
      (e.target as HTMLInputElement).value.length <= 10
    ) {
      if (
        (e.target as HTMLInputElement).value.length == 2 &&
        patientDetails?.dobFormatted?.indexOf("/") == -1
      ) {
        (e.target as HTMLInputElement).value =
          (e.target as HTMLInputElement).value + "/";
      } else if (
        (e.target as HTMLInputElement).value.length == 5 &&
        patientDetails?.dobFormatted?.lastIndexOf("/") == 2
      ) {
        (e.target as HTMLInputElement).value =
          (e.target as HTMLInputElement).value + "/";
      }
      setPatientDetails((prevState: any) => ({
        ...prevState,
        dobFormatted: (e.target as HTMLInputElement).value,
      }));
    } else {
      // let test = verifiyDoBWithPattern(e.target.value);

      ((e.target as HTMLInputElement).value as String) =
        patientDetails?.dobFormatted as String;
    }
  };
  const inputNumberVerify = (e: Event, inputField: String) => {
    inputField == "zipcode" ? clearErrors("zipcode") : clearErrors("mrn");
    let verifyZpCode = numberValidation((e.target as HTMLInputElement).value);
    if (!verifyZpCode.isSuccess) {
      if (inputField === "zipcode") {
        setIsDisabled(true);
      }

      inputField == "zipcode"
        ? setError("zipcode", {
            type: "pattern",
            message: `Zip Code ${verifyZpCode.error}`,
          })
        : setError("mrn", { type: "pattern", message: `Invalid MRN` });
    } else {
      setIsDisabled(false);
    }
  };
  const mobileInputCheck = (e: Event) => {
    clearErrors("phone");
    const re = /^[0-9\b\-]+$/;
    if (
      (e.target as HTMLInputElement).value === "" ||
      re.test((e.target as HTMLInputElement)?.value)
    ) {
      if ((e.target as HTMLInputElement).value.length <= 13) {
        if (
          (e.target as HTMLInputElement).value.length == 3 &&
          patientDetails?.mobilePhone?.indexOf("-") == -1
        ) {
          (e.target as HTMLInputElement).value =
            (e.target as HTMLInputElement)?.value + "-";
        } else if (
          (e.target as HTMLInputElement).value.length == 7 &&
          patientDetails?.mobilePhone?.lastIndexOf("-") == 3
        ) {
          (e.target as HTMLInputElement).value =
            (e.target as HTMLInputElement)?.value + "-";
        }
        setPatientDetails((prevState: any) => ({
          ...prevState,
          mobilePhone: (e.target as HTMLInputElement)?.value,
        }));
      } else {
        setPatientDetails((prevState: any) => ({
          ...prevState,
          mobilePhone: (e.target as HTMLInputElement)?.value,
        }));
        ((e.target as HTMLInputElement).value as String) =
          patientDetails?.mobilePhone as String;
      }
    } else {
      setError("phone", {
        type: "pattern",
        message: "Phone Number Must be in Numeric",
      });
      // e.target.value = e.target.value.slice(0, -1);
    }
  };
  async function initializeAllArrays() {
    debugger;
    await GetGeneralLookupData({
      localDateTime: new Date(),
      returnReferrals: true,
      returnDepartment: true,
      returnPhysician: true,
      returnTags: true,
      returnDiagnosis: true,
      returnPatientSettings: true,
      clinicianRole: false,
    })
      .then(async function (response) {
        if (response!.data.responseCode === 1) {
          await Convert(
            response!.data.patientsSettings,
            Lookups.Setting,
            "Setting",
            patientDetails?.patientSetting
          );
          await Convert(
            response!.data.tags,
            Lookups.Tags,
            " tag",
            newAllDropDown.tags.map((Item: Option) => Item.id)
          );
          await Convert(
            response!.data.referrals,
            Lookups.Referral,
            "referral",
            patientDetails?.referralId
          );
          await Convert(
            response!.data.diagnosis,
            Lookups.Diagnosis,
            "",
            newAllDropDown.diagnosis.map((Item: Option) => Item.id)
          );
          await Convert(
            response!.data.departments,
            Lookups.Department,
            "department",
            patientDetails?.departmentId
          );
          await Convert(
            response!.data.physicians,
            Lookups.Physician,
            "physician",
            patientDetails?.physicianId
          );
          // Convert(response!.data.patientsSettings, Lookups.Setting, "", patientDetails?.patientSetting);
        } else {
        }
      })
      .catch((error) => {
        history.push("/confirmation", {
          actionType: ActionType.FailureAPIResponse,
        });
      });
  }

  function setSelected(obj: any, type: Lookups) {
    debugger;
    if (type == Lookups.Setting) {
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        setting: obj,
      }));
      setSettingToggle(true);
    } else if (type == Lookups.Department) {
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        department: obj,
      }));
    } else if (type == Lookups.Physician) {
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        physician: obj,
      }));
    } else if (type == Lookups.Referral) {
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        referral: obj,
      }));
    } else if (type == Lookups.Tags) {
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        tags: obj,
      }));
      // setTagsList([...obj,...tagsList]);
    } else if (type == Lookups.Diagnosis) {
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        diagnosis: obj,
      }));
      // setDiagnosisList([...obj,...diagnosisList]);
    }
  }
  async function Convert(
    res: Option[],
    type: Lookups,
    str: String,
    selectedId: Number | Number[]
  ) {
    updateSelection(type, res);
    if (Array.isArray(selectedId)) {
      let array: Option[] = [];
      selectedId.forEach((id: any) => {
        let ob = res?.find((obj: Option) => obj.id === id);
        if (ob != undefined) {
          array.push(ob);
        }
      });
      setSelected(array, type);
    } else {
      let obj: Option = res?.filter(
        (obj: Option) => obj.id == selectedId
      )[0] as Option;

      if (obj != undefined) {
        setSelected(obj, type);
      }
    }
    if (type === Lookups.Setting) {
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        settingOpt: res,
      }));
    } else if (type === Lookups.Department) {
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        departmentOpt: res.reverse(),
      }));
    } else if (type === Lookups.Physician) {
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        physicianOpt: res.reverse(),
      }));
    } else if (type === Lookups.Referral) {
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        referralOpt: res.reverse(),
      }));
    } else if (type === Lookups.Tags) {
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        tagsOpt: res.reverse(),
      }));
    } else if (type === Lookups.Diagnosis) {
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        diagnosisOpt: res,
      }));
    }
  }
  // console.log(newAllDropDown);
  const setSelectedSettingOption = (option: any, tagName: any) => {
    if (option.id !== undefined) {
      setSettingError(false);
    }
  };
  function validateDate(dateOfBirthVal: any) {
    if (dateOfBirthVal.includes("T")) {
      dateOfBirthVal = format(new Date(dateOfBirthVal), "MM/dd/yyyy");
    }
    let newDate = new Date();
    let presentDate = newDate.getDate();
    let presentMonth = newDate.getMonth();
    let presentYear = newDate.getFullYear();
    if (dateOfBirthVal == null) {
      return false;
    }
    let pattern = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/\d{4}$/;

    let isNameValid = pattern.test(dateOfBirthVal);
    if (!isNameValid) {
      return false;
    }

    // let dateValues = dateOfBirthVal.match(pattern);
    let dateValues = dateOfBirthVal.split("/");
    if (dateValues == null) {
      return false;
    }
    let birthYear = dateValues[2];
    let birthMonth = dateValues[0];
    let birthDate = dateValues[1];
    if (birthMonth < 1 || birthMonth > 12) {
      return false;
    } else if (birthDate < 1 || birthDate > 31) {
      return false;
    } else if (
      (birthMonth == 4 ||
        birthMonth == 6 ||
        birthMonth == 9 ||
        birthMonth == 11) &&
      birthDate == 31
    ) {
      return false;
    } else if (birthYear > presentYear) {
      return false;
    } else if (birthYear == presentYear) {
      if (birthMonth > presentMonth + 1) {
        return false;
      } else if (birthMonth == presentMonth + 1) {
        if (birthDate > presentDate) {
          return false;
        }
      }
    }
    return true;
  }
  function validateSetting() {
    if (newAllDropDown.setting.id !== undefined) {
      return true;
    } else {
      return false;
    }
  }

  const RegisterPatientStep1 = (data: any) => {
    if (validateSetting()) {
      setSettingError(false);
      if (validateDate(data.dobFormatted!)) {
        let x: Option[] = [];
        try {
          localStorage.removeItem("iseditingDob");

          if (isEdit && patientDetails) {
            if (patientDetails?.tagIds) {
              newAllDropDown.tagsOpt.filter((i: Option) => {
                patientDetails?.tagIds.map((Item: Number) => {
                  if (Item === Number(i.id)) {
                    x.push(i);
                  }
                });
              });
              setTagsList([...x]);
              x = [];
            }
            if (patientDetails.diagnosisIds) {
              newAllDropDown.diagnosisOpt.filter((i: Option) => {
                patientDetails?.diagnosisIds.map((Item: Number) => {
                  if (Item === Number(i.id)) {
                    x.push(i);
                  }
                });
              });
              setDiagnosisList([...x]);
              x = [];
            }
          }
          setCreatePatientStep2(true);
        } catch (error) {
          console.error(error);
        }
      } else {
        setError("dobFormatted", {
          type: "server",
          message: "Invalid Date of Birth",
        });
      }
    } else {
      setSettingError(true);
      // console.log("setting error")
    }
  };
  async function SaveRecentSearch(fullName: string, patientid: number) {
    try {
      await SaveRecentSearchAuth({
        loggedInUserID: 0,
        search: {
          fullName: fullName,
          patientid: patientid,
        },
      }).catch((error) => {
        history.push("/confirmation", {
          actionType: ActionType.FailureAPIResponse,
        });
      });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  }
  const updateTagAndDiagnoseList = (option: any, tagName: String) => {
    if (tagName == "Tags") {
      let generateUniqueTags = removeDuplicate([...tagsList, ...option]);
      setTagsList([...generateUniqueTags]);
    } else {
      setDiagnosisList([...option]);
    }

    // resetData();
  };
  const updateList = (option: Option, tagName: String) => {
    if (tagName == "Tags") {
      // console.log("entering in tags")
      let updateTags = tagsList.filter((obj: Option) => obj.id != option.id);
      setTagsList([...updateTags]);
      setNewAllDropDown((lp: PatientFormDropdowns) => {
        let tags = [...updateTags];
        return { ...lp, tags };
      });
    } else {
      let updateTags = diagnosisList.filter(
        (obj: Option) => obj.id != option.id
      );
      setDiagnosisList([...updateTags]);
      setNewAllDropDown((lp: PatientFormDropdowns) => {
        let diagnosis = [...updateTags];
        return { ...lp, diagnosis };
      });
    }
    // resetData();
  };
  async function RegisterPatientStep2(data: any) {
    // console.log("errors.mrn",errors?.mrn?.type);
    // if(data.mrn)
    let localtime = new Date(
      new Date(data?.dobFormatted!).setHours(
        new Date(data?.dobFormatted!).getHours() -
          new Date(data?.dobFormatted!).getTimezoneOffset() / 60
      )
    ).toISOString();
    seterrorStringDisplay("");
    let patient = new PatientVM();
    patient.id = isEdit ? Number(localStorage.getItem("patientServerID")) : 0;
    patient.firstName = data.firstname;
    patient.lastName = data.lastname;
    patient.nickName = data.nickname;
    patient.email = data.email;
    patient.dob = localtime;
    patient.zip = data.zipcode;
    patient.patientSetting = newAllDropDown?.setting.id;
    patient.referralId = newAllDropDown.referral.id;
    patient.physicianId = newAllDropDown.physician.id;
    patient.departmentId = newAllDropDown.department.id;
    patient.tagIds = newAllDropDown.tags.map((Item: Option) => Item.id);
    patient.diagnosisIds = newAllDropDown.diagnosis.map(
      (Item: Option) => Item.id
    );
    patient.isTestPatient = isTestPatient;
    patient.mobilePhone =
      data.phone == null || data.phone == undefined
        ? ""
        : data.phone.replace(/-/g, "");
    patient.sex = 0;
    patient.city = "";
    patient.mrn = data.mrn;
    localStorage.setItem("patientdob", localtime);
    try {
      await RegisterPatientAuth({
        patient: patient!,
        localDateTime: new Date(),
        EncryptedServerId: localStorage.getItem("EncryptedServerId"),
      })
        .then(async function (response) {
          if (response!.data.isResponseSuccessfull) {
            seterrorStringDisplay("");
            // reset();

            if (isEdit) {
              let latestFullName = patient.firstName + " " + patient.lastName;
              let lastFullName = localStorage.getItem("fullName");
              if (latestFullName != lastFullName) {
                // now sending this call from API
                //  SaveRecentSearch(latestFullName, patient.id);
              }
              // setShowToast(true)
              // setShowToast((prevState) => ({
              //     ...prevState,
              //     show: true,
              //     string: "Patient info updated successfully"
              // }));
              history.replace("/confirmation", {
                actionType: ActionType.SuccessUpdatePatient,
              });
            } else {
              // console.log("setting patientServerID");

              localStorage.setItem("patientServerID", response!.data.id);
              let latestFullName = patient.firstName + " " + patient.lastName;
              localStorage.setItem("patientName", latestFullName);
              // setPatientDetailsRecoil(data)
              history.replace("/confirmation", {
                actionType: ActionType.SuccessCreatePatient,
              });
            }
          } else {
            if (
              response!.data.responseMessage !== "" &&
              response!.data.responseMessage !== null
            ) {
              seterrorStringDisplay(response!.data.responseMessage);
            } else if (response!.data.errorMessage !== "") {
              seterrorStringDisplay(response!.data.errorMessage);
            }
          }
        })
        .catch((error) => {
          localStorage.setItem(
            "actionType",
            ActionType.FailureAPIResponse.toString()
          );
        });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  }
  const getLookUp = (type: String) => {
    if (type == "Setting") {
      return Lookups.Setting;
    } else if (type == "Department") {
      return Lookups.Department;
    } else if (type == "Physician") {
      return Lookups.Physician;
    } else if (type === "Referral") {
      return Lookups.Referral;
    } else if (type === "Tags") {
      return Lookups.Tags;
    } else if (type === "Diagnosis") {
      return Lookups.Diagnosis;
    } else if (type === "Role") {
      return Lookups.Role;
    } else {
      return Lookups.Other;
    }
  };
  const setLookUp = (edit: boolean, id: number, name: any, type: String) => {
    // console.log("new lookups dropdown: ", newAllDropDown);
    let LookupId: Lookups = 0;
    LookupId = getLookUp(type);
    setLookUpType(LookupId);
    setIseditingLookup((prevState) => ({
      ...prevState,
      IseditingLookups: edit,
      Id: id,
      Label: name,
      LookUp: LookupId,
    }));
    setLookUpOption(true);
  };
  function removeDuplicate(obj: any) {
    let ids = obj.map((o: any) => o.id);
    return obj.filter(
      ({ id }: any, index: any) => !ids.includes(id, index + 1)
    );
  }
  const updateSelection = (type: Lookups, res: Option[]) => {
    if (type == Lookups.Tags) {
      let updateTags: Option[] = [
        ...res.filter((tag: Option) => {
          return tagsList.find((tagList: Option) => {
            if (tag.id == tagList.id) {
              return tagList;
            }
          });
        }),
      ];
      if (updateTags?.length) {
        setTagsList([...updateTags]);
      }
    } else if (type == Lookups.Referral) {
      // setNewAllDropDown((prevState: PatientFormDropdowns) => ({ ...prevState, diagnosis: obj, }));
      // setDiagnosisList([...obj,...diagnosisList]);
    }
  };
  const updateStateLookUp = async () => {
    await initializeAllArrays();
  };

  const dismissModal = async (boolean: boolean) => {
    await modal.current?.dismiss();
    setcancelModal(false);
  };
  // console.log("tagsList", tagsList)
  // console.log("showToast", showToast)
  // console.log("settingError", settingError)
  if (!createPatientStep2) {
    return (
      <>
        <IonModal
          className="cancel-modal"
          backdropDismiss={false}
          isOpen={cancelModal}
          ref={modal}
          placeholder={undefined}
        >
          <CancelModal
            setShowModal1={dismissModal}
            actionType={
              isEdit ? ActionType.EditPatient : ActionType.CreateNewPatient
            }
            reset={reset}
            isEdit={isEdit}
          ></CancelModal>
        </IonModal>
        <form
          onSubmit={handleSubmit((data) => {
            RegisterPatientStep1(data);
          })}
          autoComplete="off"
        >
          <IonPage placeholder={undefined}>
            <IonHeader className="ion-no-border" placeholder={undefined}>
              <TopLeftUserName
                headerText={"Create New Patient"}
              ></TopLeftUserName>
              <IonGrid
                className="container create-patient-pages"
                placeholder={undefined}
              >
                <IonRow className="row" placeholder={undefined}>
                  <IonCol className="col-sec" placeholder={undefined}>
                    <div className="top-inner-sec">
                      <div className="left-arrow">
                        <svg
                          className="svg-icons"
                          width="16"
                          height="26"
                          viewBox="0 0 16 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          onClick={() => {
                            localStorage.removeItem("iseditingDob");
                            goBack();
                          }}
                        >
                          <path
                            d="M14.8738 21.9379L5.75957 13.0063L14.8867 4.0621L14.8867 4.06211L14.8903 4.05847C15.706 3.24249 15.7059 1.92345 14.8738 1.10795C14.0466 0.297348 12.7153 0.297348 11.8881 1.10795L1.02777 11.7507C0.324078 12.4403 0.324078 13.5597 1.02777 14.2493L11.8881 24.892C12.7153 25.7027 14.0466 25.7027 14.8738 24.892C15.7066 24.0759 15.7066 22.754 14.8738 21.9379Z"
                            fill="#31344E"
                            stroke="black"
                          />
                        </svg>
                      </div>
                      {isEdit ? (
                        <h1>Edit Patient Information</h1>
                      ) : (
                        <h1>Create New Patient</h1>
                      )}
                      <p>Step One - Patient Information</p>
                    </div>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonHeader>
            <IonContent placeholder={undefined} className="slide-in-right">
              <IonGrid className="container" placeholder={undefined}>
                <IonRow className="row" placeholder={undefined}>
                  <IonCol className="col-sec" placeholder={undefined}>
                    <div
                      className={`field-wrap ${
                        errors.firstname && "error-wrap"
                      }`}
                    >
                      <IonLabel className="label" placeholder={undefined}>
                        First Name *
                      </IonLabel>
                      <IonInput
                        className="input-field"
                        type="text"
                        placeholder="Enter First Name"
                        onIonChange={(e: any) => {
                          namingtValidation(e, "fName");
                        }}
                        {...register("firstname", {
                          required: true,
                          // validate: (name) => {
                          //     let obj1 = validationNamePattern(name);
                          //     if (!obj1.isSuccess) {
                          //         return obj1.error.replace("Data", "First");
                          //     } else {
                          //         return true;
                          //     }
                          // }
                        })}
                      ></IonInput>
                      {errors?.firstname?.type === "validate" && (
                        <p className="error-msg">{errors.firstname.message}</p>
                      )}
                      {errors?.firstname?.type === "required" && (
                        <p className="error-msg">This field is required</p>
                      )}
                      {errors?.firstname?.type === "pattern" && (
                        <p className="error-msg">
                          First Name should start with alphanumeric
                        </p>
                      )}
                      {errors.firstname &&
                        errors.firstname.type !== "required" &&
                        errors.firstname.type === "server" &&
                        errors.firstname.message && (
                          <p>
                            This error is added in the first name server error
                          </p>
                          // <ErrorTopToaster errorString={errors.firstname.message} />
                        )}
                    </div>
                    <div
                      className={`field-wrap ${
                        errors.lastname && "error-wrap"
                      }`}
                    >
                      <IonLabel className="label" placeholder={undefined}>
                        Last Name *
                      </IonLabel>
                      <IonInput
                        className="input-field"
                        type="text"
                        placeholder="Enter Last Name"
                        onIonChange={(e: any) => {
                          namingtValidation(e, "lName");
                        }}
                        {...register("lastname", {
                          required: true,
                          // validate: (name) => {
                          //     let obj1 = validationNamePattern(name);
                          //     if (!obj1.isSuccess) {
                          //         return obj1.error.replace("Data", "Last");
                          //     } else {
                          //         return true;
                          //     }
                          // }
                        })}
                      ></IonInput>
                      {errors?.lastname?.type === "validate" && (
                        <p className="error-msg">{errors.lastname.message}</p>
                      )}
                      {errors?.lastname?.type === "required" && (
                        <p className="error-msg">This field is required</p>
                      )}
                      {errors?.lastname?.type === "pattern" && (
                        <p className="error-msg">
                          Last Name should start with alphanumeric
                        </p>
                      )}
                      {errors.lastname &&
                        errors.lastname.type !== "required" &&
                        errors.lastname.type === "server" &&
                        errors.lastname.message && (
                          <p>
                            This error is added in the last name server error
                          </p>
                          // <ErrorTopToaster errorString={errors.firstname.message} />
                        )}
                    </div>
                    <div
                      className={`field-wrap ${
                        errors.nickname && "error-wrap"
                      }`}
                    >
                      <IonLabel className="label" placeholder={undefined}>
                        Nickname{" "}
                      </IonLabel>
                      <IonInput
                        className="input-field"
                        type="text"
                        placeholder="Enter nick name"
                        onIonChange={(e: any) => {
                          namingtValidation(e, "nickName");
                        }}
                        {...register("nickname", {
                          required: false,
                          // validate: (name) => {
                          //     let obj1 = validationNamePattern(name);
                          //     if (!obj1.isSuccess) {
                          //         return obj1.error.replace("Data", "Nick");
                          //     } else {
                          //         return true;
                          //     }
                          // }
                        })}
                      ></IonInput>
                      {errors?.nickname?.type === "validate" && (
                        <p className="error-msg">{errors.nickname.message}</p>
                      )}
                      {errors?.nickname?.type === "pattern" && (
                        <p className="error-msg">
                          Nickname Name should start with alphanumeric
                        </p>
                      )}
                    </div>
                    <div
                      className={`field-wrap ${
                        errors.dobFormatted && "error-wrap"
                      }`}
                    >
                      <IonLabel className="label" placeholder={undefined}>
                        Date of Birth*
                      </IonLabel>
                      <IonInput
                        className="input-field"
                        type="text"
                        placeholder="mm/dd/yyyy"
                        // value={patientDetails?.dob != undefined ? format(new Date(patientDetails?.dob), 'MM/dd/yyyy') : ""}
                        // value={CustomValue("dob")}
                        onIonChange={(e: any) => {
                          dobValidation(e);
                        }}
                        {...register("dobFormatted", {
                          required: true,
                          // pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                        })}
                      ></IonInput>
                      {errors?.dobFormatted?.type === "required" && (
                        <p className="error-msg">This field is required</p>
                      )}
                      {errors?.dobFormatted?.type === "pattern" && (
                        <p className="error-msg">
                          Enter DOB in YYYY-MM-DD format
                        </p>
                      )}
                      {errors.dobFormatted &&
                        errors.dobFormatted.type !== "required" &&
                        errors.dobFormatted.type === "server" &&
                        errors.dobFormatted.message && (
                          //   <div className="error-top-msg">
                          //   <h2>{errors.password.message}</h2>
                          // </div>
                          <p className="error-msg">
                            {errors.dobFormatted.message}
                          </p>
                          // <ErrorTopToaster errorString={errors.dob.message} />
                        )}
                    </div>
                    <div
                      className={`field-wrap ${errors.email && "error-wrap"}`}
                    >
                      <IonLabel className="label" placeholder={undefined}>
                        Email *
                      </IonLabel>
                      <IonInput
                        className="input-field"
                        type="text"
                        placeholder="Enter email"
                        // value={patientDetails.email}
                        onIonChange={(e: any) => {
                          clearErrors("email");
                          setPatientDetails((prevState: any) => ({
                            ...prevState,
                            email: e.target.value,
                          }));
                        }}
                        // value={CustomValue("email")}
                        {...register("email", {
                          required: true,
                          pattern:
                            /^[\w+,]+(?:[.-][\w+,]+)*@\w+(?:[.-]\w+)*\.\w{2,3}$/i,
                        })}
                      ></IonInput>
                      {errors?.email?.type === "required" && (
                        <p className="error-msg">This field is required</p>
                      )}
                      {errors?.email?.type === "pattern" && (
                        <p className="error-msg">Invalid email</p>
                      )}
                      {errors.email &&
                        errors.email.type !== "required" &&
                        errors.email.type === "server" &&
                        errors.email.message && (
                          //   <div className="error-top-msg">
                          //   <h2>{errors.password.message}</h2>
                          // </div>
                          <p className="error-msg">invalid Email</p>
                          // <ErrorTopToaster errorString={errors.email.message} />
                        )}
                    </div>
                    <div
                      className={`field-wrap ${errors.zipcode && "error-wrap"}`}
                    >
                      <IonLabel className="label" placeholder={undefined}>
                        Zip Code *
                      </IonLabel>
                      <IonInput
                        className="input-field"
                        type="text"
                        placeholder="Enter Zip Code"
                        // value={patientDetails.zip}
                        onIonChange={(e: any) => {
                          inputNumberVerify(e, "zipcode");

                          setPatientDetails((prevState: any) => ({
                            ...prevState,
                            zip: e.target.value,
                          }));
                        }}
                        // value={CustomValue("zipcode")}
                        {...register("zipcode", {
                          required: true,
                          //  pattern: /^[A-Za-z]+$/i,
                        })}
                      ></IonInput>
                      {errors?.zipcode?.type === "required" && (
                        <p className="error-msg">This field is required</p>
                      )}
                      {errors.zipcode &&
                        errors.zipcode.type !== "required" &&
                        errors.zipcode.type === "server" &&
                        errors.zipcode.message && (
                          //   <div className="error-top-msg">
                          //   <h2>{errors.password.message}</h2>
                          // </div>
                          <ErrorTopToaster
                            errorString={errors.zipcode.message}
                          />
                        )}
                    </div>

                    <div
                      className={`field-wrap ${settingError && "error-wrap"}`}
                    >
                      <IonLabel className="label" placeholder={undefined}>
                        Settings *
                      </IonLabel>
                      <SelectSectionCustom
                        isEdit={isEdit}
                        placeholder="Select Setting"
                        isSearchable={false}
                        isEditableOption={false}
                        allOptions={newAllDropDown.settingOpt}
                        value={""}
                        LookUpType={"Setting"}
                        onSelectOption={setSelectedSettingOption}
                        onAddOrEditLookUp={setLookUp}
                        isMultiSelect={false}
                      />
                    </div>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonContent>
            <IonFooter className="ion-no-border" placeholder={undefined}>
              <IonGrid className="container" placeholder={undefined}>
                <IonRow className="row" placeholder={undefined}>
                  <IonCol className="col-sec" placeholder={undefined}>
                    <div className="btn-wrap-sec two-btns">
                      <IonButton
                        className="generic-btn generic-btn-outline"
                        onClick={() => {
                          setcancelModal(true);
                        }}
                        disabled={cancelModal ? true : false}
                        placeholder={undefined}
                      >
                        Cancel
                      </IonButton>
                      <IonButton
                        className="generic-btn"
                        type="submit"
                        disabled={isDisabled}
                        onClick={settingValidation}
                        placeholder={undefined}
                      >
                        Continue
                      </IonButton>
                    </div>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonFooter>
          </IonPage>
        </form>
      </>
    );
  } else {
    return (
      <>
        <IonModal
          className="cancel-modal"
          backdropDismiss={false}
          isOpen={cancelModal}
          ref={modal}
          placeholder={undefined}
        >
          <CancelModal
            setShowModal1={setcancelModal}
            actionType={
              isEdit ? ActionType.EditPatient : ActionType.CreateNewPatient
            }
            reset={reset}
            isEdit={isEdit}
          ></CancelModal>
        </IonModal>
        <IonModal
          className="create-tag-modal"
          backdropDismiss={false}
          isOpen={lookUpOption}
          placeholder={undefined}
        >
          <CreateNewLookup
            setIsLookupUpdated={updateStateLookUp}
            setShowModal2={setLookUpOption}
            LookUpType={lookUpType}
          />
        </IonModal>
        <form
          onSubmit={handleSubmit((data) => {
            RegisterPatientStep2(data);
            //  RegisterPatientStep2(data.setting, data.referral, data.physician, data.department);
          })}
          autoComplete="off"
        >
          {errorStringDisplay != null && errorStringDisplay != "" ? (
            <ErrorTopToaster errorString={errorStringDisplay} />
          ) : (
            ""
          )}
          <IonPage placeholder={undefined}>
            <IonHeader className="ion-no-border" placeholder={undefined}>
              <TopLeftUserName
                headerText={"Create New Patient"}
              ></TopLeftUserName>
              <IonGrid
                className="container create-patient-pages"
                placeholder={undefined}
              >
                <IonRow className="row" placeholder={undefined}>
                  <IonCol className="col-sec" placeholder={undefined}>
                    <div className="top-inner-sec">
                      <div className="left-arrow">
                        <svg
                          className="svg-icons"
                          width="16"
                          height="26"
                          viewBox="0 0 16 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          onClick={() => {
                            seterrorStringDisplay("");
                            setCreatePatientStep2(false);
                          }}
                        >
                          <path
                            d="M14.8738 21.9379L5.75957 13.0063L14.8867 4.0621L14.8867 4.06211L14.8903 4.05847C15.706 3.24249 15.7059 1.92345 14.8738 1.10795C14.0466 0.297348 12.7153 0.297348 11.8881 1.10795L1.02777 11.7507C0.324078 12.4403 0.324078 13.5597 1.02777 14.2493L11.8881 24.892C12.7153 25.7027 14.0466 25.7027 14.8738 24.892C15.7066 24.0759 15.7066 22.754 14.8738 21.9379Z"
                            fill="#31344E"
                            stroke="black"
                          />
                        </svg>
                      </div>
                      {isEdit ? (
                        <h1>Edit Patient Information</h1>
                      ) : (
                        <h1>Create New Patient</h1>
                      )}
                      <p>Step Two - Patient Information</p>
                    </div>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonHeader>
            <IonContent placeholder={undefined} className="slide-in-right">
              <IonGrid className="container" placeholder={undefined}>
                <IonRow className="row" placeholder={undefined}>
                  <IonCol className="col-sec" placeholder={undefined}>
                    <div
                      className={`field-wrap ${errors.phone && "error-wrap"}`}
                    >
                      <IonLabel className="label" placeholder={undefined}>
                        Mobile Phone
                      </IonLabel>
                      <IonInput
                        className="input-field"
                        type="text"
                        placeholder="(XXX) XXX-XXXX"
                        onIonChange={(e: any) => {
                          mobileInputCheck(e);
                        }}
                        {...register("phone", {
                          required: false,
                          pattern:
                            /^([0-9]( |-)?)?(\(?[0-9]{3}\)?|[0-9]{3})( |-)?([0-9]{3}( |-)?[0-9]{4,5})$/,
                        })}
                      ></IonInput>
                      {errors.phone &&
                        (errors.phone.type as unknown) == "pattern" && (
                          <p className="error-msg">
                            Invalid Mobile phone number
                          </p>
                        )}
                    </div>
                    <div className={`field-wrap ${errors.mrn && "error-wrap"}`}>
                      <IonLabel className="label" placeholder={undefined}>
                        MRN
                      </IonLabel>
                      <IonInput
                        className="input-field"
                        type="text"
                        placeholder="Enter MRN"
                        onIonChange={(e: any) => {
                          inputNumberVerify(e, "mrn");
                          setPatientDetails((prevState: any) => ({
                            ...prevState,
                            mrn: e.target.value,
                          }));
                        }}
                        {...register("mrn", {
                          required: false,
                          maxLength: 10,
                          pattern: /^[eE]?[0-9\-_"]+$/,
                        })}
                      ></IonInput>
                      {errors?.mrn?.type === "pattern" && (
                        <p className="error-msg">
                          {errors?.mrn?.message
                            ? errors?.mrn?.message
                            : "Invalid MRN"}
                        </p>
                      )}
                      {errors.mrn && (errors.mrn.type as unknown) == "mrn" && (
                        <p className="error-msg">Invalid MRN</p>
                      )}
                    </div>

                    {/* Tags */}
                    <div className="field-wrap ">
                      <IonLabel className="label" placeholder={undefined}>
                        Tags
                      </IonLabel>
                      <SelectSectionCustom
                        isEdit={isEdit}
                        placeholder="Select a Tag"
                        isSearchable={true}
                        isEditableOption={true}
                        allOptions={newAllDropDown.tagsOpt}
                        value={""}
                        LookUpType={"Tags"}
                        onSelectOption={updateTagAndDiagnoseList}
                        onAddOrEditLookUp={setLookUp}
                        isMultiSelect={true}
                      />
                      <div className="select-multi-select-wrap-main">
                        <div className="select-multi-select-wrap-main-inner">
                          {tagsList.length
                            ? tagsList.map((tag: Option) => {
                                return (
                                  <TagsName
                                    tagListName={"Tags"}
                                    tag={tag}
                                    handleSelectionData={updateList}
                                  />
                                );
                              })
                            : ""}
                        </div>
                      </div>
                    </div>
                    {/* Diagnosis */}
                    <div className="field-wrap">
                      <IonLabel className="label" placeholder={undefined}>
                        Diagnosis
                      </IonLabel>
                      <SelectSectionCustom
                        isEdit={isEdit}
                        placeholder="Select Diagnosis"
                        isSearchable={true}
                        isEditableOption={false}
                        allOptions={newAllDropDown.diagnosisOpt}
                        value={""}
                        LookUpType={"Diagnosis"}
                        onSelectOption={updateTagAndDiagnoseList}
                        onAddOrEditLookUp={setLookUp}
                        isMultiSelect={true}
                      />
                      <div className="select-multi-select-wrap-main">
                        <div className="select-multi-select-wrap-main-inner">
                          {diagnosisList.length
                            ? diagnosisList.map((diagnose: Option) => {
                                return (
                                  <TagsName
                                    tagListName={"Diagnose"}
                                    tag={diagnose}
                                    handleSelectionData={updateList}
                                  />
                                );
                              })
                            : ""}
                        </div>
                      </div>
                    </div>
                    {/* Referral */}
                    <div className="field-wrap">
                      <IonLabel className="label" placeholder={undefined}>
                        Referral
                      </IonLabel>
                      <SelectSectionCustom
                        isEdit={isEdit}
                        placeholder="Select a Referral"
                        isSearchable={false}
                        isEditableOption={true}
                        allOptions={newAllDropDown.referralOpt}
                        value={""}
                        LookUpType={"Referral"}
                        onSelectOption={setSelectedSettingOption}
                        onAddOrEditLookUp={setLookUp}
                        isMultiSelect={false}
                      />
                    </div>
                    {/* Physician */}
                    <div className="field-wrap">
                      <IonLabel className="label" placeholder={undefined}>
                        Physician
                      </IonLabel>
                      <SelectSectionCustom
                        isEdit={isEdit}
                        placeholder="Select a Physician"
                        isSearchable={false}
                        isEditableOption={true}
                        allOptions={newAllDropDown.physicianOpt}
                        value={""}
                        LookUpType={"Physician"}
                        onSelectOption={setSelectedSettingOption}
                        onAddOrEditLookUp={setLookUp}
                        isMultiSelect={false}
                      />
                    </div>
                    {/* Department */}
                    <div className="field-wrap">
                      <IonLabel className="label" placeholder={undefined}>
                        Department
                      </IonLabel>
                      <SelectSectionCustom
                        isEdit={isEdit}
                        placeholder="Select a Department"
                        isSearchable={false}
                        isEditableOption={true}
                        allOptions={newAllDropDown.departmentOpt}
                        value={""}
                        LookUpType={"Department"}
                        onSelectOption={setSelectedSettingOption}
                        onAddOrEditLookUp={setLookUp}
                        isMultiSelect={false}
                      />
                    </div>

                    <div className="field-wrap test">
                      <div className="input-field input-checkbox">
                        <IonCheckbox
                          className="checkbox-generic test-patient-checkbox"
                          checked={isTestPatient}
                          onIonChange={(e) => {
                            setisTestPatient(e.detail.checked);
                            setPatientDetails((prevState: any) => ({
                              ...prevState,
                              isTestPatient: e.detail.checked,
                            }));
                          }}
                          placeholder={undefined}
                        />
                        <IonLabel class="test-patient" placeholder={undefined}>
                          Test Patient
                        </IonLabel>
                      </div>
                    </div>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonContent>
            <IonFooter className="ion-no-border" placeholder={undefined}>
              <IonGrid className="container" placeholder={undefined}>
                <IonRow className="row" placeholder={undefined}>
                  <IonCol className="col-sec" placeholder={undefined}>
                    <div className="btn-wrap-sec two-btns">
                      <IonButton
                        className="generic-btn generic-btn-outline"
                        onClick={() => {
                          seterrorStringDisplay("");
                          if (isEdit) {
                            setcancelModal(true);
                          } else {
                            setCreatePatientStep2(false);
                          }
                        }}
                        placeholder={undefined}
                      >
                        {isEdit ? "Cancel" : "Back"}
                      </IonButton>
                      <IonButton
                        className="generic-btn"
                        type="submit"
                        placeholder={undefined}
                      >
                        {isEdit ? "Save" : "Continue"}
                      </IonButton>
                    </div>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonFooter>
          </IonPage>
        </form>
      </>
    );
  }
};
export default CreateNewPatientStep1;
